export default {"src":"/_next/static/media/0xa422885120a6e6bea36949737165d681759bb5bb.0bfe70f5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};